/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { authClientsGetMcpServerAuthentication } from "../funcs/authClientsGetMcpServerAuthentication.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { McpServerAuthentication } from "../models/components/mcpserverauthentication.js";
import {
  GetMcpServerAuthenticationRequest,
  GetMcpServerAuthenticationSecurity,
} from "../models/operations/getmcpserverauthentication.js";
import { unwrapAsync } from "../types/fp.js";
export type McpServerAuthenticationQueryData = McpServerAuthentication;

export function prefetchMcpServerAuthentication(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetMcpServerAuthenticationRequest,
  security?: GetMcpServerAuthenticationSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildMcpServerAuthenticationQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildMcpServerAuthenticationQuery(
  client$: GramCore,
  request: GetMcpServerAuthenticationRequest,
  security?: GetMcpServerAuthenticationSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<McpServerAuthenticationQueryData>;
} {
  return {
    queryKey: queryKeyMcpServerAuthentication({
      mcpServerId: request.mcpServerId,
      gramSession: request.gramSession,
      gramKey: request.gramKey,
    }),
    queryFn: async function mcpServerAuthenticationQueryFn(
      ctx,
    ): Promise<McpServerAuthenticationQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(authClientsGetMcpServerAuthentication(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyMcpServerAuthentication(
  parameters: {
    mcpServerId: string;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
  },
): QueryKey {
  return [
    "@gram/client",
    "authClients",
    "getMcpServerAuthentication",
    parameters,
  ];
}
